<template>
  <div>
    <Alert type="warning">导出前可以拖动排序【导出列项】！</Alert>
    <Form ref="form" class="editForm" :model="form" :rules="ruleValidate" :label-width="70">
      <FormItem label="导出列" prop="checkKey">
        <CheckboxGroup v-model="form.checkKey">
          <draggable v-model="keysList" handle=".mover" chosenClass="moverClass" force-fallback="true" animation="100">
            <Checkbox v-for="(item,index) in keysList.filter(item => item.key && item.type !== 'image')" border class="checkbox-border-item mover" :label="item.key" :key="index">
              {{ item.keyName || item.title }}
              <Tooltip content="该列项为系统固定配置项，导出后可能内容会错误或者不显示，请注意！" :max-width="300" v-if="item.type==='system'">
                <Icon type="ios-alert" color="#ff6600"/>
              </Tooltip>
            </Checkbox>
          </draggable>
        </CheckboxGroup>
      </FormItem>
      <FormItem label="文件名" prop="fileName">
        <Input v-model="form.fileName" placeholder="文件名"></Input>
      </FormItem>
      <!-- <FormItem label="文档标题" prop="title">
        <Input v-model="form.title" placeholder="文档标题，可不填，空时导出的文档不显示标题！"></Input>
      </FormItem> -->
    </Form>
    <div v-if="submitBtnText" class="export-progress">
      导出进度: {{ submitBtnText }}
    </div>
    <div class="modalEditBtnArea">
      <Button type="primary" @click="onOk">导出</Button>
      <Button @click="close">取消</Button>
    </div>
  </div>
</template>

<script>
import axios from '../../request'
import draggable from "vuedraggable";
import {clone, putOutClsx, getBaseDataName, formatDate, getRegionByCode, vNodeToHtml} from "../../lib/index";

export default {
  name: "export",
  components: {draggable},
  props: {
    exportAction: {type: String, default: '/excel/Export'},
    exportTitle: {type: String, default: null},
    exportFileName: {type: String, default: null},
    action: {type: String, default: null},
    method: {type: String, default: null},
    params: {type: [Object, Array], default: null},
    keyID: {type: String, default: null},
    columns: {type: Array, default: () => []},
    autoExpert: {type: Boolean, default: true}, // 是否支持自动导出列表为excel
  },
  data() {
    return {
      ruleValidate: {
        fileName: [
          {required: true, message: '请填写导出的文件名称', trigger: 'blur'}
        ],
      },
      form: {fileName: '', title: '', checkKey: [], checkListKey: [],},
      keysList: [],
      submitBtnText: '',
    }
  },
  mounted() {
    this.form.title = this.exportTitle;
    this.form.fileName = this.exportFileName || (this.$route.meta ? this.$route.meta.title : '');
    this.form.checkKey = this.columns.filter(item => !item.type).map(item => item.key)
    if (!this.columnsProp) {
      this.initData(this.columns);
    } else {
      this.getPageKeys();
    }
  },
  methods: {
    initData(data) {
      this.keysList = data.map(item => {
        let filterColumn = this.columns.filter(item => !item.type).filter(subItem => subItem.key === item.key);
        return filterColumn.length > 0 ? {
          key: filterColumn[0].key,
          keyName: filterColumn[0].title,
          type: filterColumn[0].renderConfig ? filterColumn[0].renderConfig.type : (filterColumn[0].render ? 'system' : ''),
          typeParams: filterColumn[0].renderConfig || {},
          render: filterColumn[0].render || null,
        } : item;
      });
    },
    getPageKeys() {
      this.$get('/pageListKeys/List', {keyId: this.keyID, limit: -1}).then(res => {
        if (res.code === 200) {
          if (res.data.list) {
            let columns = this.columns.filter(item => !item.type)
            this.keysList = res.data.list.map(item => {
              let filterColumn = columns.filter(subItem => subItem.key === item.key);
              return filterColumn.length > 0 ? {
                key: filterColumn[0].key,
                keyName: filterColumn[0].title,
                type: filterColumn[0].renderConfig ? filterColumn[0].renderConfig.type : '',
                typeParams: filterColumn[0].renderConfig || {},
              } : item;
            });
          } else {
            this.$post('/page-list/InsertKeys', {
              columns: this.columns.map((item, index) => {
                item.order = index + 1;
                return item;
              }), keyId: this.keyID
            }).then(res => {
              if (res.code === 200) this.getPageKeys();
            })
          }
        }
      })
    },
    async exportFile() {
      const limit = 400;
      const params = clone(this.params);
      let allData = [];
      let doneCount = 0;
      let errorFlag = false;
      const columns = this.keysList.filter(item => this.form.checkKey.indexOf(item.key) >= 0 && item.type !== 'image').map(({ ...item }) => {
        item.title = item.keyName;
        item.renderConfig = { type: item.type };
        switch (item.type) {
          case 'baseData':
            item.renderConfig.parentName = item.typeParams.parentName;
            break;
          case 'formatDate':
            item.renderConfig.fmt = item.typeParams.fmt;
            break;
          case 'area':
            item.renderConfig.key = item.typeParams.key || ['provinceName', 'cityName', 'countyName', 'streetName'];
            break;
        }
        delete item.type;
        return item;
      });
      this.$parent.$parent.spinShow = true;
      for (let i = 1; i <= Math.ceil((params.total || 1) / limit); i++) {
        params.page = i;
        let param;
        if (Array.isArray(params)) {
          param = [];
          params.forEach(parentItem => {
            let obj = '';
            Object.keys(parentItem).forEach((item, index) => {
              if (item === 'limit') parentItem[item] = limit;
              obj = obj + item + '=' + (parentItem[item] == undefined ? '' : parentItem[item]) + (index !== Object.keys(parentItem).length - 1 ? '&' : '');
            });
            param.push(obj);
          });
        } else {
          if (params.limit >= 0) params.limit = limit;
        }
        try {
          const res = await this.$get(this.action, params);
          if (res.code === 200) {
            doneCount++;
            const targetData = (res.data.list || []).map((item, index) => {
              columns.forEach(column => {
                switch (column.renderConfig.type) {
                  case 'baseData':
                    item[column.key] = getBaseDataName(column.renderConfig.parentName, item[column.key]);
                    break;
                  case 'formatDate':
                    item[column.key] = item[column.key] ? formatDate(new Date(item[column.key]), column.renderConfig.fmt) : '';
                    break;
                  case 'area':
                    const key = column.renderConfig.key;
                    const full = column.renderConfig.full || false;
                    let value = '';
                    if (Array.isArray(key) && key.length > 0) {
                      for (let i = 0; i < key.length; i++) {
                        if (item[key[i]]) {
                          let name;
                          if (column.renderConfig) {
                            name = getRegionByCode(item[key[i]]);
                            value = i === 0 ? name : (value + '-' + name);
                            if (name) break;
                          } else {
                            name = item[key[i]];
                            value = i === 0 ? name : (value + '-' + name);
                          }
                        }
                      }
                      if (!value) value = item[key];
                    } else {
                      if (item.provinceName && full) {
                        value = item.provinceName;
                      }
                      if (item.cityName) {
                        value = value + (value ? '-' : '') + item.cityName;
                      }
                      if (item.countyName) {
                        value = value + (value ? '-' : '') + item.countyName;
                      }
                      if (item.streetName) {
                        value = value + (value ? '-' : '') + item.streetName;
                      }
                    }
                    item[column.key] = value;
                    break;
                  default:
                    item[column.key] = (item[column.key] && typeof item[column.key] === 'number' && item[column.key].toString().length > 11)
                      ? String(item[column.key]) : item[column.key];
                    break;
                }
                if (column.render && column.renderConfig.type === 'system') {
                  const vNode = column.render(this.$createElement, { row: item, index: index });
                  item[column.key] = vNodeToHtml(vNode);
                }
              });
              return item;
            });
            allData = allData.concat(targetData);
            // 更新导出进度
            this.submitBtnText = ((doneCount / Math.ceil(params.total / limit)) * 100).toFixed(2) + '%';
          } else {
            errorFlag = true;
            break;
          }
        } catch (err) {
          console.log(err);
          errorFlag = true;
          break;
        }
      }
      if (errorFlag) {
        this.$Notice.error({ title: "操作失败！", desc: '导出异常，请稍后再试！' });
      } else {
        // 最终处理导出的数据并触发下载
        putOutClsx(this.form.fileName, columns, allData, { header: 'title' });
      }
      this.$parent.$parent.spinShow = false; // 隐藏加载中
      this.close();
    },

    onOk() {
      this.$parent.$parent.spinShow = true;
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.exportFile()
        }
      })
    },
    close() {
      this.$emit('on-close')
    },
  }
}
</script>

<style scoped>
.checkbox-border-item {
  margin-bottom: 10px;
  padding: 0 10px;
}
.export-progress {
  margin-top: 10px;
  color: #2d8cf0;
  position: absolute;
  top: 60%; /* 使其显示在上方 */
  left: 50%;
  transform: translateX(-50%); /* 居中 */
  z-index: 9999; /* 确保显示在其他内容的上方 */
}
</style>